import { EMAIL, PHONE } from "../constants/site";
import Icon from "./Icon";

export default function TopBar({ isVisible = true }) {
  const marqueeItems = [
    { icon: "mail", text: `✉ Email Us: ${EMAIL}` },
    { icon: "language", text: "Global Locations: UK | USA | CANADA | AUSTRALIA | NEW ZEALAND | UAE | KSA" },
    { icon: "stars", text: "✨ Register Today with Certified Expert Tutors!" },
    { icon: "verified", text: "Male & Female Certified Native Arab & Hafiz Quran Teachers" },
    { icon: "schedule", text: "24/7 Flexible Scheduling & 1-on-1 Personalized Live Classes" },
  ];

  return (
    <div
      className={`bg-gradient-to-r from-[#003828] via-[#044d38] to-[#003828] text-white transition-all duration-300 ease-in-out border-b border-amber-500/30 ${
        isVisible
          ? "max-h-14 opacity-100 translate-y-0 py-1.5"
          : "max-h-0 opacity-0 -translate-y-full py-0 border-none pointer-events-none"
      }`}
    >
      <div className="max-w-max-width mx-auto page-x flex items-center justify-between gap-2.5 sm:gap-4 text-xs font-body-md overflow-hidden">
        {/* Left: Email */}
        <a
          href={`mailto:${EMAIL}`}
          className="flex items-center gap-1.5 hover:text-amber-300 transition-colors shrink-0 font-medium group text-[#e2f7ed]"
          title="Send email"
        >
          <span className="p-1 rounded-full bg-emerald-800/60 group-hover:bg-amber-400 group-hover:text-emerald-950 transition-all flex items-center justify-center">
            <Icon name="mail" className="text-[13px] sm:text-[14px]" />
          </span>
          <span className="tracking-wide hidden min-[480px]:inline text-[11px] sm:text-xs">{EMAIL}</span>
          <span className="tracking-wide min-[480px]:hidden text-[11px]">Email</span>
        </a>

        {/* Center: Animated Marquee Banner */}
        <div className="flex-1 overflow-hidden relative mx-2 py-0.5 mask-gradient">
          <div className="flex items-center whitespace-nowrap animate-marquee">
            {/* Sequence 1 */}
            <div className="flex items-center gap-8 pr-8">
              {marqueeItems.map((item, idx) => (
                <span
                  key={`m1-${idx}`}
                  className="inline-flex items-center gap-2 font-medium text-amber-200/90 text-[11px] sm:text-xs tracking-wide"
                >
                  <Icon name={item.icon} className="text-amber-400 text-xs shrink-0" />
                  {item.text}
                </span>
              ))}
            </div>
            {/* Sequence 2 (Duplicate for seamless loop) */}
            <div className="flex items-center gap-8 pr-8" aria-hidden="true">
              {marqueeItems.map((item, idx) => (
                <span
                  key={`m2-${idx}`}
                  className="inline-flex items-center gap-2 font-medium text-amber-200/90 text-[11px] sm:text-xs tracking-wide"
                >
                  <Icon name={item.icon} className="text-amber-400 text-xs shrink-0" />
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Right: Phone / Let's Talk */}
        <a
          href={`tel:${PHONE}`}
          className="flex items-center gap-1.5 hover:text-amber-200 transition-colors shrink-0 font-semibold group bg-amber-500/20 hover:bg-amber-500/30 px-2.5 py-1 rounded-full border border-amber-400/40 text-amber-300"
          title="Call or WhatsApp us"
        >
          <span className="p-0.5 rounded-full bg-amber-400 text-emerald-950 flex items-center justify-center group-hover:scale-110 transition-transform">
            <Icon name="call" className="text-[13px]" />
          </span>
          <span className="tracking-tight text-[11px] sm:text-xs">
            <span className="hidden md:inline font-normal text-emerald-100/90 mr-1">Let's Talk :</span>
            {PHONE}
          </span>
        </a>
      </div>
    </div>
  );
}
